/* Mi & My header: menu drawer, bag drawer, and Add To Bag for the whole site.
   Any element with data-mm-add adds to the Shopify cart:
     data-mm-add="123456"                        one variant
     data-mm-add='[{"id":1,"quantity":1},...]'  several variants in ONE request */
(function(){
  var MM = window.MM = window.MM || {};
  var $ = function(id){ return document.getElementById(id); };
  var nav=$('mmNav'), burger=$('mmBurger'), drawer=$('mmDrawer'), cart=$('mmCart'), scrim=$('mmScrim');
  if(!nav) return;

  addEventListener('scroll', function(){ nav.classList.toggle('scrolled', scrollY > 40); }, {passive:true});

  function menu(o){ burger.setAttribute('aria-expanded', String(o)); drawer.classList.toggle('open', o); }
  burger.addEventListener('click', function(){ menu(burger.getAttribute('aria-expanded') !== 'true'); });
  $('mmCloseDrawer').addEventListener('click', function(){ menu(false); });
  drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ menu(false); }); });

  function openC(){ cart.classList.add('on'); scrim.classList.add('on'); cart.setAttribute('aria-hidden','false'); }
  function closeC(){ cart.classList.remove('on'); scrim.classList.remove('on'); cart.setAttribute('aria-hidden','true'); }
  MM.openBag = openC; MM.closeBag = closeC;
  $('mmOpenCart').addEventListener('click', function(e){ e.preventDefault(); openC(); });
  $('mmCloseCart').addEventListener('click', closeC);
  scrim.addEventListener('click', closeC);
  addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeC(); menu(false); } });

  function money(cents){
    var f = MM.moneyFormat || '${{amount}}';
    var n = (cents/100);
    var withDec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDec = Math.floor(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if(k === 'amount_no_decimals') return noDec;
      if(k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return withDec;
    });
  }
  MM.money = money;
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function freeShip(total){
    var msg=$('mmFreeMsg'), bar=$('mmFreeBar'), t=MM.freeShip||0;
    if(!msg || !t) { if(msg) msg.textContent=''; return; }
    bar.style.width = Math.min(100, total/t*100) + '%';
    msg.textContent = total >= t ? msg.dataset.done : msg.dataset.more.replace('[amount]', money(t-total));
  }
  function render(c){
    $('mmBagCount').textContent = c.item_count;
    $('mmSubtotal').textContent = money(c.total_price);
    var body=$('mmCartBody');
    body.innerHTML = c.items.length ? c.items.map(function(i){
      return '<div class="nci"><div><div class="nci-t">'+esc(i.product_title)+'</div><div class="nci-s">Qty '+i.quantity+'</div></div><div>'+money(i.final_line_price)+'</div></div>';
    }).join('') : '<p class="nempty">'+esc(body.dataset.empty)+'</p>';
    freeShip(c.total_price);
  }
  MM.refreshBag = function(){ return fetch(MM.routes.cart + '.js', {headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(render); };
  freeShip(MM.cartTotal || 0);

  MM.addToBag = function(items){
    return fetch(MM.routes.cart + '/add.js', {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify({ items: items })
    }).then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
      .then(function(){ return MM.refreshBag(); })
      .then(function(){
        document.dispatchEvent(new CustomEvent('mm:cart-updated'));
        if(!document.getElementById('mmCartPage')) openC();
      });
  };

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-mm-add]');
    if(!b || b.disabled) return;
    e.preventDefault();
    var raw = b.getAttribute('data-mm-add'), items;
    try { items = raw.trim().charAt(0) === '[' ? JSON.parse(raw) : [{ id: +raw, quantity: 1 }]; } catch(err){ return; }
    var was = b.innerHTML; b.disabled = true;
    MM.addToBag(items).then(function(){
      if(b.hasAttribute('data-mm-added')){ b.innerHTML = b.getAttribute('data-mm-added'); setTimeout(function(){ b.innerHTML = was; }, 1400); }
    }).catch(function(err){
      b.innerHTML = (err && err.description) ? esc(err.description) : 'Could not add';
      setTimeout(function(){ b.innerHTML = was; }, 2200);
    }).then(function(){ b.disabled = false; });
  });
})();

/* Remembers what the shopper looked at (by product handle), so the cart's exit
   offer can suggest the right thing. Any link with data-track="handle" counts,
   and product pages call MM.track() on load. */
(function(){
  var MM = window.MM = window.MM || {};
  MM.track = function(handle){
    if(!handle) return;
    try{
      var v = JSON.parse(sessionStorage.getItem('mm_viewed') || '[]').filter(function(x){ return x !== handle; });
      v.unshift(handle);
      sessionStorage.setItem('mm_viewed', JSON.stringify(v.slice(0, 8)));
    }catch(e){}
  };
  document.addEventListener('click', function(e){
    var el = e.target.closest('[data-track]');
    if(el) MM.track(el.getAttribute('data-track'));
  });
  if(MM.viewing) MM.track(MM.viewing);
})();
